import PropTypes from "prop-types";
import React from "react";
import { connect, Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as firebase from "firebase";
import Layout from "../components/Layout";
import About from "./About";
import Bot from "./Bot";
import BotFinish from "./BotFinish";
import Contact from "./Contact";
import Home from "./Home";
import Login from "./Login";
import NewPart from "./NewPart";
import NewUser from "./NewUser";
import NotFound from "./NotFound";
import Part from "./Part";
import Splash from "./Splash";
import User from "./User";
import { operations } from "../state/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBllSQKGSaMzb5dN2resduqFYH_JNJmyac",
  authDomain: "gndrv-179903.firebaseapp.com",
  databaseURL: "https://gndrv-179903.firebaseio.com",
  projectId: "gndrv-179903",
  storageBucket: "gndrv-179903.appspot.com",
  messagingSenderId: "932129398319",
};
firebase.initializeApp(firebaseConfig);

class Root extends React.Component {
  componentDidMount() {
    const { setUser } = this.props;
    firebase.auth().onAuthStateChanged(user => {
      setUser(user);
      this.forceUpdate();
    });
  }

  render() {
    const { currentUser, loaded, store } = this.props;
    const authSwitch = (path, AuthComponent, NoAuthComponent) => (
      <Route
        exact
        path={path}
        component={
          // eslint-disable-next-line no-nested-ternary
          loaded ? (currentUser ? AuthComponent : NoAuthComponent) : null
        }
      />
    );
    return (
      <Provider store={store}>
        <Router>
          <Layout {...this.props}>
            <Switch>
              {authSwitch("/", Home, Splash)}
              {authSwitch("/part/new", NewPart, NotFound)}
              <Route path="/about" component={About} />
              <Route path="/slack/finish_auth" component={BotFinish} />
              <Route path="/slack" component={Bot} />
              <Route path="/contact" component={Contact} />
              <Route path="/login" component={Login} />
              <Route path="/user/new" component={NewUser} />
              <Route path="/:username/:partName" component={Part} />
              <Route path="/:username" component={User} />
              <Route component={NotFound} />
            </Switch>
          </Layout>
        </Router>
      </Provider>
    );
  }
}

Root.propTypes = {
  currentUser: PropTypes.shape({
    email: PropTypes.string,
  }),
  loaded: PropTypes.bool,
  setUser: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

Root.defaultProps = {
  currentUser: null,
  loaded: false,
};

const mapStateToProps = state => ({ ...state.auth });
const mapDispatchToProps = dispatch => ({
  setUser: id => dispatch(operations.setUser(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/pages/Root.js